import { render, staticRenderFns } from "./TarifariosFluvialesForm.vue?vue&type=template&id=b2253db2"
import script from "./TarifariosFluvialesForm.vue?vue&type=script&lang=js"
export * from "./TarifariosFluvialesForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports